<template>
  <div>
    <div v-if="categories" class="section-header">
      <span>Categories</span>
    </div>
    <div class="categories-container">
      <div
        v-for="category in categories"
        :key="category.id"
        class="category-box"
        @click="$emit('changeCategory', category.id)"
      >
        <div :class="{'category-image-container': true, 'no-image': category.id === 'onSale'}">
          <img v-if="category.id !== 'onSale'" :src="category.image_url">
          <div v-else>
            <div>
              <div>ON SALE</div>
              <div>NOW</div>
            </div>
          </div>
        </div>
        <div class="name">
          {{ category.name }}
        </div>
      </div>
      <div
        v-if="categories"
        key="all"
        class="category-box"
        @click="$emit('changeCategory', 'all')"
      >
        <div class="category-image-container no-image">
          <div>
            <div>
              <div>ALL</div>
              <div>PRODUCTS</div>
            </div>
          </div>
        </div>
        <div class="name">
          All Products
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    categories: {
      required: true, type: Array, default() {
        return [];
      },
    },
    hideCartControls: {required: false, type: Boolean, default: false},
    fromExternalLink: {required: false, default: false, type: Boolean},
    baseUrlForExternal: {required: false, type: String, default: null},
    productsContainerAdditionalClass: {required: false, type: String, default: null},
  },
  methods: {
    addToCart: function (productId, quantity) {
      this.$store.dispatch('addProduct', {productId: productId, quantity: parseInt(quantity, 10)});
    },
  },
};
</script>
